import React from 'react'
import Header from './Header'
import { faq } from '../../Data/data'

const Faq = () => {
  return (
    <div className="w-full h-full bg-black px-5 py-14 flex justify-center items-center gap-8 flex-wrap sm:px-8 lg:px-16 lg:py-20">
      <Header
        title={"Frequently Asked Questions"}
        subtitle={"Answers to Common Questions About Our Services"}
        description={
          "We understand that property management can raise a lot of questions. Here are answers to some of the most common inquiries from residential and commercial property owners in the San Francisco & Bay Area."
        }
      />
       <div className="grid w-full max-w-[1320px] grid-cols-1 gap-4 mt-2 sm:grid-cols-2 lg:grid-cols-3">
              {faq.map((data, index) => (
                <div key={index} className="min-h-[220px] w-full bg-[#141414] border border-[#262626] rounded-lg flex flex-col p-5 gap-5 sm:p-7">
                   <h1 className='font-bold text-[24px] text-gradient'>{data.question}</h1>
                   <p className='font-light text-[18px] text-white'>{data.answer}</p>
                </div>
              ))}
            </div>
    </div>
  )
}

export default Faq
